<template>
    <div class="question-list">
        <transition-group name="slide-in">
            <div
                v-for="(group, groupName, index) in questionGroups"
                :key="`key-${index}`"
                class="question-list__items"
            >
                <h3 class="question-list__items-title" v-html="groupName">
                    {{ groupName }}
                </h3>
                <div
                    v-for="(item, index) in group"
                    :key="index"
                    class="question-list__item"
                >
                    <question-card
                        :question="item.question"
                        :answer="item.answer"
                        :is-all-active="isAllActive"
                    />
                </div>
            </div>
        </transition-group>
        <transition name="slide-in">
            <div class="question-list__empty" v-if="questionItems.length === 0">
                <h3 class="no-result">
                    {{ translateNoResult }}
                </h3>
            </div>
        </transition>
        <div class="question-list__footer">
            <div class="scroll-trigger" ref="infiniteScrollTrigger" />
            <div class="circle-loader" v-if="showLoader">
                <span class="icon"></span>
                <span class="text">{{ translateLoadMore }}</span>
            </div>
        </div>
    </div>
</template>

<script>
require("intersection-observer");
import QuestionCard from "./QuestionCard.vue";

export default {
    name: "QuestionList",
    components: {
        "question-card": QuestionCard,
    },
    props: {
        questionItems: Array,
        isAllActive: Boolean,
    },
    data() {
        return {
            currentTotal: 0,
            currentQuestions: 1,
            maxPerLoad: 10,
            showLoader: false,
            translateNoResult: window.Drupal.t(
                "Sorry no results matched your criteria"
            ),
            translateLoadMore: window.Drupal.t("Load more results"),
        };
    },
    computed: {
        questionGroups() {
            const newItemList = this.questionItems.slice(
                0,
                this.questionsShowOffset
            );
            return this.groupBy(newItemList, "category");
        },
        totalQuestions() {
            return this.questionItems.length;
        },
        questionsCount() {
            return Math.ceil(this.totalQuestions / this.maxPerLoad);
        },
        questionsShowOffset() {
            const calculated = this.maxPerLoad * this.currentQuestions;
            return calculated < this.totalQuestions
                ? calculated
                : this.totalQuestions;
        },
    },
    methods: {
        groupBy(array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
        getIndex(el) {
            if (el <= 10) return el;
            const result =
                el - this.maxPerLoad * Math.floor(el / this.maxPerLoad);
            return result === 0 ? 10 : result;
        },
        scrollTrigger() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (
                        entry.intersectionRatio > 0 &&
                        this.currentQuestions < this.questionsCount
                    ) {
                        this.showLoader = true;
                        setTimeout(() => {
                            this.currentQuestions += 1;
                            this.showLoader = false;
                        }, 1000);
                    }
                });
            });

            observer.observe(this.$refs.infiniteScrollTrigger);
        },
        compareCurrentTotal() {
            if (this.currentTotal !== this.totalQuestions) {
                this.currentTotal = this.totalQuestions;
                this.currentQuestions = 1;
            }
        },
        checkCurrent() {
            return this.currentTotal !== this.totalQuestions;
        },
    },
    mounted() {
        this.scrollTrigger();
    },
    updated() {
        this.compareCurrentTotal();
    },
};
</script>

<style lang="less">
@mobile: ~"only screen and (max-width: 767px)";
@tablet: ~"only screen and (min-width: 768px) and (max-width: 999px)";
.translateFont() {
    &:lang(zh-hant),
    &:lang(zh-hans) {
        font-size: 18px;
    }
}
@keyframes loadingCircle {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.urao-faq-section .urao-faq__body {
    .question-list {
        &__items {
            margin-bottom: 60px;

            &-title {
                font-size: 25px;

                @media @mobile {
                    font-size: 20px;
                }
            }
        }
        &__item {
            position: relative;
            padding: 30px 0;
            border-bottom: 1px solid #e6e7e8;
            @media @mobile {
                padding: 30px 0 20px;
            }

            .question-item {
                &__question {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    font-size: 20px;
                    line-height: 1.2em;
                    font-weight: 700;

                    @media @tablet, @mobile {
                        font-size: 16px;
                    }
                }
                &__answer {
                    transition: 0.3s all ease;
                    opacity: 0;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    font-size: 16px;
                    line-height: 1.2em;
                    color: #6d6e71;
                    padding-top: 0;
                    max-height: 0;
                    .translateFont();

                    @media @tablet {
                        font-size: 12px;
                    }
                }
            }
            .question,
            .answer {
                &-icon {
                    flex: 0 0 30px;
                    margin-right: 10px;
                    line-height: 0;
                    min-height: 30px;
                }
                &-text {
                    flex: 1 1;
                }
            }
            .accordion-icon {
                flex: 0 0 20px;
                display: flex;
                align-items: center;
                margin-left: 10px;

                &--open,
                &--close {
                    transition: 0.3s all ease;
                }
                &--close {
                    transform: rotate(180deg);
                }
            }
            .question-container {
                &.active {
                    .question-item__answer {
                        opacity: 1;
                        padding-top: 20px;
                    }
                }
            }
        }
        &__empty,
        &__loader {
            text-align: center;
            margin-top: 30px;
        }
        &__footer {
            position: relative;

            .circle-loader {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                margin-top: 20px;

                .text {
                    margin-left: 30px;
                }
                .icon {
                    position: absolute;
                    transform: translate(-50%, -50%);
                    width: 20px;
                    height: 20px;
                    background-image: url("/themes/custom/usturao/img/svg/icon_loading.svg");
                    background-repeat: no-repeat;
                    animation: loadingCircle 1.5s infinite linear;
                }
            }
        }
    }
}
</style>
